var u = (r, t, e) => {
  if (!t.has(r))
    throw TypeError("Cannot " + e);
};
var p = (r, t, e) => {
  if (t.has(r))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(r) : t.set(r, e);
};
var n = (r, t, e) => (u(r, t, "access private method"), e);
import { E as c } from "./Exporter-70879e53.mjs";
var s, h;
class x extends c {
  constructor(e) {
    super(e);
    p(this, s);
    n(this, s, h).call(this);
  }
}
s = new WeakSet(), h = function() {
  const e = (o, a, i, l) => {
    this.send(this.queue.getAllWithClear());
  };
  ["pushState", "replaceState", "go", "back"].forEach((o) => {
    window.history[o] = new Proxy(window.history[o], {
      apply(a, i, l) {
        return e(), a.apply(i, l);
      }
    });
  });
};
export {
  x as default
};
